import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state() {
    return {
      id: null,
      relativeVersionId: null,
      type: null,
      published: false,
      entityPublishedVersionStartPublicationDate: null,
      entityPublished: false,
      entityScheduled: false,
      hasBeenPublished: false,
      isDraft: false,
      isDirty: false,
      isPreview: false,
      selectedPreviewUrl: null,
      downloadUrl: null,
      original: {
        channels: {
          master: {},
        },
      },
      fieldsConfig: [],
      currentChannel: 'master',
      availableChannels: [],
      availableLanguages: [],
      currentLanguage: null,
      channels: {
        master: {
          form: {
            pristine: true,
            dirty: false,
            valid: true,
            invalid: false,
            touched: false,
            untouched: true,
            validated: false,
          },
          formErrors: [],
          formFields: {},
          draft: {},
        },
      },
      publicUrl: null,
      publicDraftUrl: null,
      advancedMode: false,
      beforeSaveCallbacks: [],
      beforePublishCallbacks: [],
    };
  },
};
